(function () {
  'use strict';

  /* ── Sticky header shadow on scroll ─────────────── */
  var hdr = document.querySelector('.site-header');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* ── Sticky buy bar visibility ───────────────────── */
  var bar  = document.querySelector('.sticky-bar');
  var hero = document.querySelector('.hero-section');
  if (bar && hero) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('visible', !entries[0].isIntersecting);
      bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0 }).observe(hero);
  }

  /* ── Mobile hamburger menu ───────────────────────── */
  var ham = document.querySelector('.hamburger');
  var mob = document.querySelector('.mobile-nav');
  if (ham && mob) {
    ham.addEventListener('click', function () {
      var open = mob.classList.toggle('open');
      ham.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mob.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mob.classList.remove('open');
        ham.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── FAQ accordion ───────────────────────────────── */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ── Spectrum bars animate on scroll ─────────────── */
  var specBars = document.querySelectorAll('.spec-bar');
  var sciChart = document.querySelector('.sci-chart');
  if (specBars.length && sciChart) {
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        specBars.forEach(function (b) { b.classList.add('go'); });
      }
    }, { threshold: 0.4 }).observe(sciChart);
  }

  /* ── Qty +/- buttons (event delegation) ──────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn-v');
    if (!btn) return;
    var wrap = btn.closest('.qty-wrap');
    if (!wrap) return;
    var inp = wrap.querySelector('.qty-input-v');
    if (!inp) return;
    var val = parseInt(inp.value, 10) || 1;
    inp.value = (btn.dataset.dir === '+') ? val + 1 : Math.max(1, val - 1);
  });

  /* ── Product image gallery ───────────────────────── */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-thumb');
    if (!thumb) return;
    var mainImg = document.getElementById('pdp-main-img');
    if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    document.querySelectorAll('.pdp-thumb').forEach(function (b) {
      b.classList.remove('active');
    });
    thumb.classList.add('active');
  });

  /* ── ADD TO CART ─────────────────────────────────────
     Sends JSON to /cart/add.js then redirects to checkout.
     Does NOT clone forms (that breaks Shopify's token).
     Uses data-cart-bound to prevent duplicate listeners.
  ───────────────────────────────────────────────────── */
  function bindCartForms() {
    document.querySelectorAll('form.buy-form').forEach(function (form) {
      if (form.dataset.cartBound === '1') return;
      form.dataset.cartBound = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('button[name="add"]');
        if (!btn || btn.disabled) return;

        /* Get variant ID */
        var sel = form.querySelector('select[name="id"]');
        var hid = form.querySelector('input[name="id"]');
        var variantId = sel ? sel.value : (hid ? hid.value : '');

        if (!variantId) {
          showErr(form, 'Please select your iPhone model first.');
          return;
        }

        /* Get quantity */
        var qtyEl = form.querySelector('input[name="quantity"]');
        var qty   = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

        /* Loading state */
        var origHTML = btn.innerHTML;
        btn.innerHTML = 'Adding&hellip;';
        btn.disabled  = true;

        /* POST to Shopify cart API as JSON */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept':       'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
        })
        .then(function (res) {
          if (res.ok) {
            btn.innerHTML = '&#10003; Going to checkout&hellip;';
            /* Redirect straight to Shopify checkout */
            window.location.href = '/checkout';
          } else {
            return res.json().then(function (data) {
              throw new Error(data.description || data.message || 'Could not add to cart.');
            });
          }
        })
        .catch(function (err) {
          btn.innerHTML = origHTML;
          btn.disabled  = false;
          showErr(form, err.message || 'Something went wrong. Please try again.');
        });
      });
    });
  }

  function showErr(form, msg) {
    var el = form.querySelector('.atc-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'atc-error';
      el.style.cssText = 'color:#c8321a;font-size:13px;margin-top:10px;text-align:center;font-weight:500;';
      var btn = form.querySelector('button[name="add"]');
      if (btn) btn.insertAdjacentElement('afterend', el);
      else form.appendChild(el);
    }
    el.textContent = msg;
    setTimeout(function () { el.textContent = ''; }, 5000);
  }

  /* Run on page load */
  bindCartForms();

  /* Re-run after Shopify theme editor section reloads */
  document.addEventListener('shopify:section:load', bindCartForms);

  /* ── Scroll-to helpers used by non-purchase buttons ──
     Only used by "How It Works", "See the Science" etc.
     NOT used by any purchase/cart buttons.
  ───────────────────────────────────────────────────── */
  window.auricScrollTo = function (id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };



  /* ── PDP variant selector: update button URL + price ── */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (sel.id !== 'pdp-variant') return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var btn = document.getElementById('pdp-checkout-btn');
    if (btn && opt.dataset.url) btn.href = opt.dataset.url;
    if (btn && opt.dataset.price) {
      btn.textContent = 'Buy Now — ' + opt.dataset.price;
    }
    /* Update displayed price */
    var priceEl = document.getElementById('pdp-price');
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
  });

  /* ════════════════════════════════════════════════════
     SCROLL ANIMATION ENGINE (added)
     - reveal on scroll (with directions + stagger)
     - parallax drift
     - count-up stats
     - scroll progress bar
  ════════════════════════════════════════════════════ */
  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Auto-tag common blocks so animation works without editing every section */
  function autoTag() {
    var revealSelectors = [
      '.what-card', '.install-card', '.sci-benefit',
      '.review-card', '.faq-item', '.showcase-spec', '.spec-row',
      '.problem-content', '.problem-visual', '.science-grid > *',
      '.showcase-grid > *', '.buy-grid > *', '.section-head', '.collab-item'
    ];
    revealSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('reveal')) el.classList.add('reveal');
      });
    });
    /* Center-align section heading wrappers as reveal targets */
    document.querySelectorAll('.what-section .wrap > div:first-child, .how-section .wrap > div:first-child, .install-section .wrap > div:first-child, .reviews-section .wrap > div:first-child, .faq-section .wrap > div:first-child, .showcase-section .wrap > div:first-child')
      .forEach(function (el) { if (!el.classList.contains('reveal')) el.classList.add('reveal'); });

    /* Stagger grids */
    ['.what-grid', '.install-steps'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('reveal-stagger');
        el.querySelectorAll('.reveal').forEach(function (c) { c.classList.remove('reveal'); });
      });
    });
  }
  autoTag();

  if (reduceMotion) {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) {
      el.classList.add('in-view');
    });
  } else {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) {
      revealObs.observe(el);
    });

    /* ── Count-up stats ── */
    function countUp(el) {
      var raw = el.getAttribute('data-count') || el.textContent;
      var match = raw.match(/([\d.,]+)/);
      if (!match) return;
      var suffix = raw.replace(match[1], '');
      var target = parseFloat(match[1].replace(/,/g, ''));
      var decimals = (match[1].split('.')[1] || '').length;
      var dur = 1300, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = (target * eased);
        var shown = decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString();
        el.textContent = shown + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          countUp(entry.target);
          countObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-count]').forEach(function (el) { countObs.observe(el); });

    /* ── Parallax drift on scroll ── */
    var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('.parallax'));
    var ticking = false;
    function applyParallax() {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-speed') || '0.12');
        var base  = el.getAttribute('data-base') || '';
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var offset = (center - vh / 2) * -speed;
        el.style.transform = base + ' translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    if (parallaxEls.length) {
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(applyParallax); ticking = true; }
      }, { passive: true });
      applyParallax();
    }
  }

  /* ── Scroll progress bar (always, cheap) ── */
  if (!reduceMotion) {
    var bar2 = document.createElement('div');
    bar2.className = 'scroll-progress';
    document.body.appendChild(bar2);
    window.addEventListener('scroll', function () {
      var h = document.documentElement;
      var scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight);
      bar2.style.width = (scrolled * 100).toFixed(2) + '%';
    }, { passive: true });
  }

  /* ════════════════════════════════════════════════════
     ENHANCED SCROLL FX (added v2)
  ════════════════════════════════════════════════════ */
  if (!reduceMotion) {
    /* 1) Word-by-word headline rise on the big display headings */
    var headlineSel = '.display-xl, .display-lg, .lsb-headline';
    document.querySelectorAll(headlineSel).forEach(function (h) {
      if (h.dataset.fxDone) return;
      h.dataset.fxDone = '1';
      /* Split top-level text nodes into word spans, preserve <br> and <em> */
      var nodes = Array.prototype.slice.call(h.childNodes);
      h.classList.add('fx-words');
      h.innerHTML = '';
      nodes.forEach(function (node) {
        if (node.nodeType === 3) { /* text */
          node.textContent.split(/(\s+)/).forEach(function (tok) {
            if (tok.trim() === '') { h.appendChild(document.createTextNode(tok)); return; }
            var w = document.createElement('span');
            w.className = 'fx-word';
            w.innerHTML = '<span class="fx-word-inner">' + tok + '</span>';
            h.appendChild(w);
          });
        } else if (node.nodeName === 'BR') {
          h.appendChild(node);
        } else if (node.nodeName === 'EM') {
          /* keep em color; wrap its words */
          node.textContent.split(/(\s+)/).forEach(function (tok) {
            if (tok.trim() === '') { h.appendChild(document.createTextNode(tok)); return; }
            var w = document.createElement('span');
            w.className = 'fx-word';
            var em = document.createElement('em');
            em.className = 'fx-word-inner';
            em.textContent = tok;
            w.appendChild(em);
            h.appendChild(w);
          });
        } else {
          h.appendChild(node);
        }
      });
      revealObs.observe(h);
    });

    /* 2) Scroll-velocity skew — page subtly leans into fast scrolls */
    var skewTargets = document.querySelectorAll('main > * , .lsb-section, section');
    var lastY = window.scrollY, vel = 0, raf2 = false;
    function skewTick() {
      vel *= 0.82;
      var s = Math.max(-4, Math.min(4, vel * 0.05));
      document.querySelectorAll('.fx-skew-target').forEach(function (el) {
        el.style.transform = 'skewY(' + s.toFixed(2) + 'deg)';
      });
      if (Math.abs(vel) > 0.4) { requestAnimationFrame(skewTick); }
      else {
        document.querySelectorAll('.fx-skew-target').forEach(function (el) {
          el.style.transform = '';
        });
        raf2 = false;
      }
    }
    /* tag a few large blocks as skew targets */
    document.querySelectorAll('.what-grid, .how-steps, .install-steps, .reviews-track, .showcase-grid')
      .forEach(function (el) { el.classList.add('fx-skew-target'); });
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      vel = y - lastY;
      lastY = y;
      if (!raf2) { raf2 = true; requestAnimationFrame(skewTick); }
    }, { passive: true });

    /* 3) Floating product reacts to scroll: rotate + scale slightly */
    var floatWrap = document.querySelector('.lsb-float-wrap');
    if (floatWrap) {
      var floatImg = floatWrap.querySelector('.lsb-float');
      window.addEventListener('scroll', function () {
        var rect = floatWrap.getBoundingClientRect();
        var prog = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        prog = Math.max(0, Math.min(1, prog));
        if (floatImg) {
          var rot = (prog - 0.5) * 16;   /* -8deg .. 8deg */
          var sc  = 0.94 + prog * 0.12;  /* 0.94 .. 1.06 */
          floatImg.style.transform = 'rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
          floatImg.style.animation = 'none'; /* take over from idle float while scrolling */
        }
      }, { passive: true });
    }
  }

  /* ── Before / After comparison slider ── */
  (function () {
    var range  = document.getElementById('ba-range');
    var before = document.getElementById('ba-before');
    var handle = document.getElementById('ba-handle');
    if (!range || !before || !handle) return;
    function setPos(v) {
      before.style.width = v + '%';
      handle.style.left  = v + '%';
    }
    range.addEventListener('input', function () { setPos(this.value); });
    setPos(range.value);
  })();

  /* ── Buy section variant selector updates checkout URL ── */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (sel.id !== 'buy-variant-select') return;
    var btn = document.getElementById('buy-section-btn');
    if (!btn) return;
    var opt = sel.options[sel.selectedIndex];
    if (opt && opt.dataset.url) {
      btn.href = opt.dataset.url;
    }
  });

  /* ── Product page variant selector updates checkout link ── */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (sel.id !== 'pdp-variant') return;
    var varId = sel.value;
    /* Update any direct checkout links on the page */
    document.querySelectorAll('a[href*="/cart/"][href*="/checkout"]').forEach(function(link) {
      if (link.id === 'buy-section-btn' || link.classList.contains('buy-direct-btn')) return;
      link.href = '/cart/' + varId + ':1/checkout';
    });
  });

})();
